export { default } from './TripPassengerManifest'; 